export default "<p>courses-container works!</p>\n"